export default "/images/warning.svg?15ccc16e1ccda19a8099c06cbb3b8c4a";